// uid: <BWR-FIN_STMT_YTD_Q3-FILE>
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2247
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsExpressLoan,
  IsBetweenMidNovAndDec,
  IsForProfit,
} from '../rules';
import IsBusinessEstablishedLessThan from '../rules/IsBusinessEstablishedLessThan';

class FinancialStatementQ3Ruleset implements Ruleset {
  private forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const isBetweenMidNovAndDec = IsBetweenMidNovAndDec.evaluate(data);

    const isExpress = IsExpressLoan.evaluate(data);
    const establishedLessThanThreeYearsAgo =
      IsBusinessEstablishedLessThan.setYears(3).evaluate(data);

    if (isBetweenMidNovAndDec) {
      // A) Between Mid Nov and Dec && Is Express Loan && Established Less Than Three Years Ago
      if (isExpress && establishedLessThanThreeYearsAgo) {
        return RulesetResult.REQUIRED;
        // B) Between Mid Nov and Dec && Is Core, Express Plus, Industry PG or PPA (meaning Not Express)
      } else if (!isExpress) {
        return RulesetResult.REQUIRED;
      }
    }

    return RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isForProfit = IsForProfit.evaluate(data);
    const isBetweenMidNovAndDec = IsBetweenMidNovAndDec.evaluate(data);

    // If For Profit
    if (isForProfit) return this.forProfitResult(data);

    // If Not For Profit
    if (isBetweenMidNovAndDec) {
      return RulesetResult.REQUIRED;
    }

    return RulesetResult.HIDDEN;
  };
}

export default new FinancialStatementQ3Ruleset();
